import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Ico_Check",
  "use": "Ico_Check-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"Ico_Check\">\n    <path data-name=\"Rectangle 1432\" style=\"fill:none;opacity:.149\" d=\"M0 0h24v24H0z\" />\n    <path data-name=\"Path 12276\" d=\"m9.905 17.061-4.9-4.917.708-.706 4.155 4.165 7.647-8.6.747.664z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol